import React from 'react';
import moment from 'moment';
import { PersonOutline, ArrowForward } from '@mui/icons-material';
import { Chip, IconButton } from '@mui/material';
import { colors } from 'Constants/Colors';
import useTranslation from 'Hooks/useTranslation';
import { GOOGLE_MAPS_URL, LOCALES, MEET } from 'Constants/General';
import useSessionComponent from './Hooks/useSessionComponent';
import {
  CardContainer,
  DateInfo,
  DayInfo,
  DetailContainer,
  LocationInfo,
  TimeInfo,
  CapacityContainer,
  dayNumber,
  dayText,
  monthText,
  timeText,
  capacityText,
  AttendanceContainer,
} from './style';

export default function DateCard({ dateInfo, onClick, isEmployee, userCount }) {
  const { t2 } = useTranslation('Generic');
  const { date, address, meetUrl, description } = dateInfo;
  const sessionType = dateInfo.LessonType.name;
  const time = dateInfo.time === null ? t2('AllDay') : moment(dateInfo?.time, 'HH:mm:ss').format('hh:mm A');

  const accentColor = sessionType === MEET ? colors.GREEN_SHINING_ULTRA : colors.BLUE;

  const dateObject = new Date(`${date} 00:00`);
  const dayNum = dateObject.getDate();
  const dayName = dateObject.toLocaleDateString(LOCALES, { weekday: 'long' });
  const month = dateObject.toLocaleDateString(LOCALES, { month: 'long' });
  const year = dateObject.getFullYear();
  const { sessionComponent } = useSessionComponent({
    sessionType,
    meetUrl,
    address,
  });

  let attendanceStatus = 'missingCapture';

  const statusOptions = {
    missingCapture: {
      color: colors.GRAY,
      text: t2('NoRecord'),
    },
    sent: {
      color: colors.GREEN_SHINING_ULTRA,
      text: t2('Published'),
    },
    notSent: {
      color: colors.BLUE,
      text: t2('NotPublished'),
    },
  };

  if (dateInfo.userLessons.length > 0) {
    attendanceStatus = 'notSent';
  }

  if (!dateInfo.containsDraft && dateInfo.userLessons.length > 0) {
    attendanceStatus = 'sent';
  }

  return (
    <CardContainer>
      <DateInfo style={{ borderLeft: `0.3rem solid ${accentColor}` }}>
        <div style={dayNumber}>{dayNum}</div>
        <DayInfo>
          <div style={dayText}>{dayName.toUpperCase()}</div>
          <div
            style={monthText}
          >{`${t2('Of').toLowerCase()} ${month.charAt(0).toUpperCase() + month.slice(1)} ${year}`}</div>
        </DayInfo>
      </DateInfo>
      <DetailContainer>
        <a
          href={sessionType === MEET ? meetUrl : `${GOOGLE_MAPS_URL}/${address}`}
          target="_blank"
          style={{ cursor: 'pointer', textDecoration: 'none' }}
          rel="noreferrer"
        >
          <LocationInfo>{sessionComponent}</LocationInfo>
          <TimeInfo>
            <div style={timeText}>{`${time}`}</div>
          </TimeInfo>
        </a>
        <CapacityContainer>
          <PersonOutline style={{ color: accentColor, fontSize: '2.5vmin' }} />
          <div style={capacityText}>
            {dateInfo?.attendedCount}/{userCount}
          </div>
        </CapacityContainer>
        {!isEmployee && (
          <AttendanceContainer>
            <Chip
              style={{
                fontWeight: 'bold',
                fontSize: '0.8vmax',
                fontFamily: 'var(--app-font)',
                background: statusOptions[attendanceStatus].color,
              }}
              label={statusOptions[attendanceStatus].text}
            />
            <IconButton onClick={onClick}>
              <ArrowForward style={{ color: accentColor, fontSize: '2.5vmin' }} />
            </IconButton>
          </AttendanceContainer>
        )}
      </DetailContainer>
    </CardContainer>
  );
}
